import { ACCOUNT_TYPES, CURRENCY, WALLET_TYPES } from '~/types'
import { ASSET_ACTIONS } from './const'

// API REQUESTS & RESPONSES
export type DashboardAssetListResponse = {
  assets: Account[]
  totalBalance: string
}
// END API REQUESTS & RESPONSES

// DATA TYPES
export enum STATE_STATUS {
  ERROR = 'ERROR',
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
}

export type AccountTransactionLimitIncrementDate = {
  sum: string
  date: string
}

export type AccountLimitation = {
  max: string
  remaining: string
  used: string
}

type WithdrawalLimit = {
  withdrawalDaily: AccountLimitation
  withdrawalPerTransaction?: AccountLimitation
}

type WithdrawalLimitations = {
  [key in FIAT_NETWORKS]: WithdrawalLimit
}

enum FIAT_NETWORKS {
  FAST = 'fast',
  MEPS = 'meps',
  SWIF = 'swift',
}

export enum ACCOUNT_NAMES {
  GENERAL_WALLET = 'General Wallet',
  DIGITAL_GOODS = 'Digital Goods',
}

export type Account = {
  accountId: number
  balance: string
  currency: CURRENCY
  deletedAt: string
  formattedBalance: string
  fundPoolId: number
  limitations: WithdrawalLimitations
  name: ACCOUNT_NAMES
  type: ACCOUNT_TYPES
  uniqueId: string
  walletId: WALLET_TYPES
  walletName: string
  balanceInBaseCurrency?: string
}
// END DATA TYPES

// ACTION TYPES
type ResetAccountList = {
  type: typeof ASSET_ACTIONS.RESET_ASSET_LIST
}

type SetAccountList = {
  type: typeof ASSET_ACTIONS.SET_ASSET_LIST
  accountList: Account[]
  totalBalance: string
}

type SetErrorState = {
  type: typeof ASSET_ACTIONS.SET_ERROR_STATE
}

type SetLoadingState = {
  type: typeof ASSET_ACTIONS.SET_LOADING_STATE
}
// END ACTION TYPES

export type ActionTypes = ResetAccountList | SetAccountList | SetErrorState | SetLoadingState
